export default {
  name: 'input_checkbox',
  component_path: 'modules/procedures/blocks/BlockInputCheckbox'
}